export default process.env.REACT_APP_DEFAULT_URL ?? 'createappnow.com';
